import { memo } from 'react';

import { PopularTags, type PopularTagsProps } from '~/components/Tags/PopularTags';
import { usePrivateTags } from '~/swr-hooks/usePrivateTags';

export type PrivatePopularTagsProps = Pick<PopularTagsProps, 'className' | 'onTagClick'>;

export const PrivatePopularTags = memo(({ className, onTagClick }: PrivatePopularTagsProps) => {
  const { data: popularTags } = usePrivateTags({
    search: '',
    sortBy: 'highestCount',
    limit: 10,
  });

  if (!popularTags) {
    return null;
  }

  return <PopularTags className={className} onTagClick={onTagClick} tags={popularTags} />;
});

PrivatePopularTags.displayName = 'PrivatePopularTags';
